import request from 'sb-request'
import { reducers } from 'redux/core'
import { getFeatureToggle } from 'helpers'
import { constants, getGqlQuery } from 'common/helpers'


const reset = () => reducers.view.brandPage.set({})

const fetch = (slug) => request.post('graphql?name=products', {
  body: {
    query: `{
      ${getGqlQuery('brandBySlug', { slug })} {
        name,
        logo,
        description,
        products {
          id
          url
          sex
          img
          type
          name
          brand
          labels
          category
          typeGroup
          upchargePrice
        }
      }
    }`,
  },
  withErrorModal: false,
  modifyResult: ({ brandBySlug }) => brandBySlug || {},
})
  .then(
    (result) => {
      reducers.view.brandPage.set(result)
      return result
    },
    () => {
      reset()
      return {}
    }
  )


export default {
  reset,
  fetch,
}
